export default (theme) => ({
    root: {
        marginTop: '30px'
    },
    title: {
        fontFamily: '"Bodoni Moda", Sans-serif',
        fontSize: '37px !important',
        lineHeight: '50px',
        fontWeight: 600,
        marginTop: '15px'
    },
    titleHeader: {
        border: '1px solid',
        padding: '10px',
        marginBottom: '20px'
    },
    img: {
        maxHeight: '50px'
    },
    borderbBottom: {
        borderBottom: '1px solid #576d7a',
    },
    domanda: {
        marginTop: '15px'
    }
})
